class SkrolliteEvent {

	get VIEWPORT_IN() { return 'viewportIn'; }
	get VIEWPORT_OUT() { return 'viewportOut'; }

}

export default new SkrolliteEvent();
